module.exports = __webpack_public_path__ + "img/filter_icon.312c1180.svg";